import { render } from "./FacetPanelRecursiveList.vue?vue&type=template&id=f963a6a0&scoped=true&ts=true"
import script from "./FacetPanelRecursiveList.vue?vue&type=script&lang=ts"
export * from "./FacetPanelRecursiveList.vue?vue&type=script&lang=ts"

import "./FacetPanelRecursiveList.vue?vue&type=style&index=0&id=f963a6a0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f963a6a0"]])

export default __exports__